module.exports = __webpack_public_path__ + "img/hr-electric-mining-drill-S-patch.3e770dd6.png";